var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.$attrs,false),[(_vm.icon)?_c('v-icon',{staticClass:"mr-2"},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }